/* eslint-disable import/no-extraneous-dependencies */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const iframeUrl = `${window.config.APPLICATIONMANAGER_API}/public/xdSessionStoragePostMessageApi.html`;
let started = false;
let xdReady = false;

function installXdSessionStorageFallback() {
  const storage = window.sessionStorage;
  window.xdSessionStorage = {
    init: ({ initCallback } = {}) => {
      if (typeof initCallback === 'function') initCallback();
    },
    getItem: (key, callback) => {
      let value = null;
      try {
        value = storage.getItem(key);
      } catch (_error) {
        value = null;
      }
      if (typeof callback === 'function') {
        callback({ key, value });
      }
      return value;
    },
    setItem: (key, value, callback) => {
      try {
        storage.setItem(key, value);
      } catch (_error) {
        // no-op: fallback storage unavailable
      }
      if (typeof callback === 'function') callback();
    },
    removeItem: (key, callback) => {
      try {
        storage.removeItem(key);
      } catch (_error) {
        // no-op: fallback storage unavailable
      }
      if (typeof callback === 'function') callback();
    },
    clear: (callback) => {
      try {
        storage.clear();
      } catch (_error) {
        // no-op: fallback storage unavailable
      }
      if (typeof callback === 'function') callback();
    },
  };
}

const startApp = () => {
  if (started) return;
  started = true;
  const root = createRoot(document.getElementById('root'));
  root.render(<App />);
};

if (window.xdSessionStorage && typeof window.xdSessionStorage.init === 'function') {
  // Fail-open startup: allow x-domain session bridge to initialize first, then fallback safely.
  setTimeout(() => {
    if (xdReady) return;
    installXdSessionStorageFallback();
    startApp();
  }, 2500);
  try {
    window.xdSessionStorage.init({
      iframeUrl,
      initCallback: () => {
        xdReady = true;
        startApp();
      },
    });
  } catch (_error) {
    installXdSessionStorageFallback();
    startApp();
  }
} else {
  installXdSessionStorageFallback();
  startApp();
}
